import Timeline from "@mui/lab/Timeline";
import TimelineItem, { timelineItemClasses } from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineDot from "@mui/lab/TimelineDot";
import Box from "@mui/material/Box";
import { Drawer, Grid, IconButton, Modal, Typography, useMediaQuery, useTheme } from "@mui/material";
import HealthAndSafetyOutlinedIcon from '@mui/icons-material/HealthAndSafetyOutlined';
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAppointmentHistory } from "../../store/crm/appointment";
import moment from "moment";
import { TimelineContent } from "@mui/lab";
import CustomButtoncolor from "../custom-button/customColorButton";
import CloseIcon from "@mui/icons-material/Close";

const TreatmentTab = (customer_id) => {
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  // //console.log("id get",customerId, bookingId )
  // const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const handleCloseModal = () => {
    handleClose();
  };
  // getAppointmentHistory({
  //     user_id:appointmentDetails?.customer?.id,type:'Appointments'
  // })
  const crmAppointmentStore = useSelector(
    (state) => state?.crmAppointmentStore
  );
  const {
    invoices = [],
    appointmentsHistory = [],
    treatments = [],
    walletHistory = {},
  } = crmAppointmentStore;
  // useEffect(()=>{
  //     (async ()=>{

  //         if (customer_id){
  //             // setWalletLoading(true)
  //             await dispatch(
  //                 getAppointmentHistory({
  //                     user_id:customer_id,type:'Treatments'
  //                 })
  //             )
  //             // setWalletLoading(false)
  //         }
  //     })()
  // },[])
  const handleOpen = async () => {
    if (customer_id) {
      setLoading(true);
      await dispatch(
        getAppointmentHistory({
          user_id: customer_id?.customer_id,
          type: "Treatments",
        })
      );
      setLoading(false);
    }
    setOpen(true);
  };
  const handleAppointmentClick = (url) => {
    // Open the appointment in a new tab instead of navigating in place.
    window.open(url, "_blank", "noopener,noreferrer");
  };
  const theme = useTheme();
const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <>
      <CustomButtoncolor
        handleClick={handleOpen}
        mainColor={"#219653"}
        size="md"
        val="Treatment History"
        style={{
          padding: "7px 5px",
          fontSize: "18px",
          minWidth: "max-content",
          borderRadius: "6px!important",
          width: "100%",
          "@media (minWidth: 420px)": {
            width: "auto",
          },
          "@media (max-width:319px)": {
            fontSize: "15px",
          },
        }}
      />
      {/* {loading?<Waveloading fullSize/>:''} */}
      <Drawer
        anchor="right"
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: { xs: '100%', sm: 640, md: 760, lg: 900 },
            maxWidth: '100vw',
            background: '#fff',
            boxShadow: '-12px 0 40px rgba(0,0,0,0.10)',
            display: 'flex',
            flexDirection: 'column',
          },
        }}
      >
        {/* Header — brand-styled panel */}
        <Box sx={{
          position: 'relative',
          display: 'flex', alignItems: 'flex-start', gap: 1.25,
          px: 2.5, py: 2,
          borderBottom: '1px solid #F0CDDB',
          flexShrink: 0,
        }}>
          <Box sx={{
            width: 42, height: 42, borderRadius: '10px',
            background: '#FAEFF5', border: '1px solid #F0CDDB',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            flexShrink: 0,
          }}>
            <HealthAndSafetyOutlinedIcon sx={{ color: '#A72C68', fontSize: 22 }} />
          </Box>
          <Box sx={{ flex: 1, pr: 3 }}>
            <Typography sx={{ fontWeight: 700, fontSize: '17px', color: '#1a1a2e', lineHeight: 1.2, fontFamily: 'helvetica-lt-std-bold' }}>
              Treatment History
            </Typography>
            <Typography sx={{ fontSize: '12px', color: '#6B7280', mt: '2px' }}>
              Past treatments and clinical notes for this customer.
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={handleClose}
            sx={{
              position: 'absolute', top: 10, right: 10,
              color: '#6B7280', borderRadius: '8px',
              width: 32, height: 32,
              border: '1px solid #F0CDDB',
              '&:hover': { background: '#FAEFF5', color: '#A72C68' },
            }}
          >
            <CloseIcon sx={{ fontSize: 18 }} />
          </IconButton>
        </Box>

        {/* Body */}
        <Box sx={{ flex: 1, overflowY: 'auto', background: '#F1F5F9', p: { xs: 2, sm: 3 } }}>
          {treatments?.length > 0 ? (
            <Timeline
              sx={{
                p: "0",
                my: "0",
                [`& .${timelineItemClasses.root}:before`]: {
                  flex: 0,
                  padding: 0,
                },
              }}
              position="right"
            >
              {treatments?.length > 0 &&
                treatments.map((treatment, index) => (
                  <TimelineItem sx={{ minHeight: "200px" }} key={index}>
                    <TimelineSeparator
                      sx={{ display: { xs: "none", sm: "flex" } }}
                    >
                      <TimelineConnector
                        sx={{
                          background: "#2F80ED",
                          width: "16px",
                          borderRadius: "10px",
                          border: "6px solid #fff",
                          maxHeight: "50px",
                          mb: "-10px",
                          borderTop: index === 0 ? "6px solid #fff" : "0",
                          borderTopLeftRadius: index === 0 ? "10px" : "0",
                          borderTopRightRadius: index === 0 ? "10px" : "0",                        }}
                      />
                      <TimelineDot
                        variant="outlined"
                        sx={{
                          mx: "auto",
                          my: "0",
                          borderWidth: "5px",
                          // borderColor: getBorderColor(treatment?.status),
                          zIndex: "10",
                        }}
                      />
                      <Box
                        sx={{
                          height: "75px",
                          width: "90px",
                          mt: "-8px",
                          background: "#fff",
                          borderRadius: "5px",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          flexDirection: "column",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handleAppointmentClick(
                            `/crm/appointment/details/${treatment?.id}`
                          )
                        }
                      >
                        <Typography sx={{ fontSize: "13px" }}>
                          Booking No
                        </Typography>
                        <Typography
                          sx={{ fontSize: "13px", fontWeight: "600" }}
                        >
                          {treatment?.id}
                        </Typography>
                      </Box>
                      <TimelineConnector
                        sx={{
                          background: "#2F80ED",
                          width: "16px",
                          bord0erRadius: "10px",
                          border: "6px solid #fff",
                          borderBottomLeftRadius: "0",
                          borderBottomRightRadius: "0",
                          borderBottom: "0",
                          mt: "-7px",
                        }}
                      />
                    </TimelineSeparator>
                    <TimelineContent
                      sx={{
                        pl: { xs: "0px", sm: "32px" },
                        pb: { xs: "8px", sm: "32px" },
                        pt: 0,
                        pr: 0,
                      }}
                    >
                      <Box
                        sx={{
                          p: { xs: "12px", sm: "24px" },
                          background: "#fff",
                          height: "100%",
                          borderRadius: "10px",
                        }}
                      >
                        <Typography
                          variant="body2"
                          color="initial"
                          sx={{
                            color: "#56CCF2",
                            fontSize: "16px",
                            fontFamily: "helvetica-lt-std-bold",
                          }}
                        >
                          {treatment?.provider_name}
                        </Typography>
                        <Grid
                          container
                          spacing={{ xs: 1.5, sm: 2 }}
                          sx={{ mt: 0.5 }}
                        >
                          <Grid item xs={12} sm={5} xl={4}>
                            <Box>
                              <Typography
                                variant="body2"
                                color="initial"
                                sx={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  fontWeight: 600,
                                }}
                              >
                                Appointment Date:
                              </Typography>
                              <Typography
                                color="initial"
                                sx={{
                                  mt: 1,
                                  fontFamily: "helvetica-lt-std-bold",
                                  fontSize: isMobile ? "15px" : "18px",
                                  lineHeight: 1.3,
                                  color: treatment.date ? "#000" : "#F25022",
                                }}
                              >
                                {treatment?.date
                                  ? moment(treatment?.date).format(
                                      "dddd MMMM D, YYYY"
                                    )
                                  : "Date and time not set"}
                              </Typography>
                              {treatment?.date && (
                                <Typography
                                  color="initial"
                                  sx={{
                                    mt: 0.5,
                                    fontFamily: "helvetica-lt-std-bold",
                                    fontSize: isMobile ? "15px" : "18px",
                                  }}
                                >
                                  {treatment?.start_time} -{" "}
                                  {treatment?.end_time}
                                </Typography>
                              )}
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={7} xl={8}>
                            <Box>
                              <Typography
                                variant="body2"
                                color="initial"
                                sx={{
                                  color: "#000",
                                  textDecoration: "underline",
                                  fontWeight: 600,
                                }}
                              >
                                Treatment Invoice:
                              </Typography>
                              <Box
                                sx={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "flex-start",
                                  gap: 1,
                                  mt: 1.5,
                                }}
                              >
                                <Typography
                                  variant="body2"
                                  color="initial"
                                  sx={{ minWidth: 0, overflowWrap: "anywhere" }}
                                >
                                  {treatment?.service_names}
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="initial"
                                  sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
                                >
                                  ${treatment?.grand_total}
                                </Typography>
                              </Box>
                            </Box>
                            <Box>
                              <Box sx={{ display: "flex", mt: 1.5 }}>
                                <Typography variant="body2" color="initial" sx={{ fontFamily:'helvetica-lt-std-bold' }}>
                                  Aesthetician:
                                </Typography>
                                <Typography
                                  variant="body2"
                                  color="initial"
                                  sx={{ ml: 1 }}
                                >
                                  {treatment?.aesthetician}
                                </Typography>
                              </Box>
                            </Box>
                          </Grid>
                        </Grid>

                        <Box
                          sx={{
                            mt: 2.5,
                            pt: 2,
                            borderTop: "1px solid #EEF2F6",
                          }}
                        >
                          <Typography
                            variant="body2"
                            color="initial"
                            sx={{
                              color: "#000",
                              textDecoration: "underline",
                              fontWeight: 600,
                              mb: 1,
                            }}
                          >
                            Notes
                          </Typography>

                          {[
                            {
                              label: "Customer Notes",
                              entries: treatment?.notes?.Customer,
                            },
                            {
                              label: "Staff Notes",
                              entries: treatment?.notes?.Staff,
                            },
                            {
                              label: "Medical Notes",
                              entries: treatment?.notes?.Medical,
                            },
                          ].map(({ label, entries }) => (
                            <Box
                              key={label}
                              sx={{
                                display: "flex",
                                flexDirection: { xs: "column", sm: "row" },
                                alignItems: "flex-start",
                                gap: { xs: 0.25, sm: 2 },
                                py: 1,
                                "&:not(:last-of-type)": {
                                  borderBottom: "1px solid #F5F7FA",
                                },
                              }}
                            >
                              <Typography
                                variant="body2"
                                sx={{
                                  width: { xs: "100%", sm: "132px" },
                                  flexShrink: 0,
                                  color: "#6B7280",
                                  lineHeight: 1.6,
                                }}
                              >
                                {label}
                              </Typography>
                              <Box sx={{ flex: 1, minWidth: 0, width: "100%" }}>
                                {entries?.length > 0 ? (
                                  entries.map((note, noteIndex) => (
                                    <Typography
                                      key={noteIndex}
                                      variant="body2"
                                      color="initial"
                                      sx={{
                                        lineHeight: 1.6,
                                        overflowWrap: "anywhere",
                                        "&:not(:first-of-type)": { mt: 0.75 },
                                      }}
                                    >
                                      <Box
                                        component="span"
                                        sx={{
                                          fontFamily: "helvetica-lt-std-bold",
                                          mr: 0.5,
                                        }}
                                      >
                                        [
                                        {moment(note?.created_at).format(
                                          "h:mm A"
                                        )}
                                        ,{" "}
                                        {moment(note?.created_at).format(
                                          "YYYY-MM-DD"
                                        )}
                                        ] {note?.staff?.name}:
                                      </Box>
                                      {note?.description}
                                    </Typography>
                                  ))
                                ) : (
                                  <Typography
                                    variant="body2"
                                    sx={{ color: "#9CA3AF", lineHeight: 1.6 }}
                                  >
                                    None
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          ))}
                        </Box>
                      </Box>
                    </TimelineContent>
                  </TimelineItem>
                ))}
            </Timeline>
          ) : (
            <Box sx={{
              minHeight: 320,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 1.25,
            }}>
              <Box sx={{
                width: 84, height: 84, borderRadius: '50%',
                background: '#FAEFF5',
                border: '1px dashed #F0CDDB',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
              }}>
                <HealthAndSafetyOutlinedIcon sx={{ color: '#A72C68', fontSize: 36 }} />
              </Box>
              <Typography sx={{ fontWeight: 800, color: '#1a1a2e', fontSize: 18, fontFamily: 'helvetica-lt-std-bold' }}>
                No Treatment List
              </Typography>
              <Typography sx={{ fontSize: 13, color: '#6B7280' }}>
                Past treatments will appear here once recorded.
              </Typography>
            </Box>
          )}
        </Box>
      </Drawer>
    </>
  );
};

export default TreatmentTab;
